const STORAGE_KEY = 'sshhelper-theme'
export const THEMES = ['night', 'day']
const DEFAULT_THEME = 'night'

/** The theme the viewer last chose, or night. Storage can throw in private mode, so it is guarded. */
export function readTheme() {
    try {
        const stored = localStorage.getItem(STORAGE_KEY)
        return THEMES.includes(stored) ? stored : DEFAULT_THEME
    } catch {
        return DEFAULT_THEME
    }
}

export function applyTheme(theme) {
    const next = THEMES.includes(theme) ? theme : DEFAULT_THEME
    document.documentElement.setAttribute('data-theme', next)

    // Keeps the iOS status bar and Android chrome in step with the page.
    const meta = document.querySelector('meta[name="theme-color"]')
    if (meta) {
        meta.setAttribute('content', next === 'day' ? '#f2f5f9' : '#0b1220')
    }

    try {
        localStorage.setItem(STORAGE_KEY, next)
    } catch {
        // A viewer who blocks storage still gets the theme, just not the memory of it.
    }
    return next
}
